.line {
  font-size: 15px;
  margin-bottom: 5px;
}
.line a {
  color: white;
}
.caret {
  animation: blink-caret 0.75s step-end infinite;
  border-right: 0.15em solid white;
}
.hidden {
  display: none;
}

.section:not(:last-child) {
  margin-bottom: 40px;
}
@keyframes blink-caret {
  from,
  to {
    border-color: transparent;
  }
  50% {
    border-color: white;
  }
}
